var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    stroke: "#E41818",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4317 54.9776L53.6378 52.7714C54.0338 52.3755 54.0338 52.0361 53.6378 51.6401L43.6818 41.684L53.2419 32.1239C53.6378 31.7279 53.5813 31.4451 53.1853 31.0491L51.262 29.1258C50.866 28.7298 50.5831 28.6732 50.1872 29.0692L40.6271 38.6293L30.671 28.6732C30.275 28.2773 29.9356 28.2773 29.5396 28.6732L27.3335 30.8794C26.8809 31.332 26.8809 31.6714 27.2769 32.0674L37.233 42.0234L27.6163 51.6401C27.2203 52.0361 27.2769 52.3189 27.6729 52.7149L29.5962 54.6382C29.9922 55.0342 30.275 55.0908 30.671 54.6948L40.2877 45.0781L50.2437 55.0342C50.6397 55.4302 50.9791 55.4302 51.4317 54.9776Z",
    fill: "#E41818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.edd77d9eccc9da2af0f5ab36c716431f.svg";
export { ForwardRef as ReactComponent };